import { render, staticRenderFns } from "./BoardDetail.vue?vue&type=template&id=70fa9174&scoped=true&"
import script from "./BoardDetail.vue?vue&type=script&lang=js&"
export * from "./BoardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa9174",
  null
  
)

export default component.exports